module.exports = " <div class=cells> <div class=row v-for=\"(index, r) in rows\"> <div v-if=\"index != 0 || (outerBorder == true || outerBorder == 'true')\" class=hairline-top></div> <div class=col v-for=\"c in cols\" @click=\"cellClicked(r*cols.length + c)\"> <div v-if=c class=hairline-left></div> {{{ items[r*cols.length + c] }}} </div> </div> <div v-if=\"outerBorder == true || outerBorder == 'true'\" class=hairline-bottom></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cells/cells.vue
// module id = 232
// module chunks = 0